import React, {
  useContext,
  useMemo,
  useCallback,
  createContext,
  useState,
} from 'react'
import PropTypes from 'prop-types'
import { LiveChatLoaderProvider, Intercom } from 'react-live-chat-loader'

import { IS_PROD } from '@/config'

const IntercomContext = createContext(null)

export const useIntercom = () => useContext(IntercomContext)

const FACADE_CLASSNAME = 'pm-intercom-facade-container'

export const getIntercomAppId = (isProd = IS_PROD) => (isProd ? 'quse8o11' : 'm9jgpgp3')

export const INTERCOM_APP_ID = getIntercomAppId(IS_PROD)

const IntercomProvider = ({ children }) => {
  const [isIntercomReady, setIntercomReady] = useState(false)

  const openChat = useCallback(() => {
    window.Intercom?.('show')
  }, [])

  const handleReady = useCallback(() => {
    setIntercomReady(true)
  }, [])

  const providerValue = useMemo(() => ({
    isIntercomReady,
    openChat,
  }), [isIntercomReady, openChat])

  return (
    <LiveChatLoaderProvider idlePeriod="500" onReady={handleReady} provider="intercom" providerKey={INTERCOM_APP_ID}>
      <IntercomContext.Provider value={providerValue}>
        {children}
      </IntercomContext.Provider>
      <Intercom color="#515EDA" containerClass={FACADE_CLASSNAME} />
    </LiveChatLoaderProvider>
  )
}

IntercomProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default IntercomProvider
